import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ColorModeContext } from '../theme';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import { Menu, MenuItem } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { APP_HEADER_HEIGHT } from './layouts/appHeader';

type TopNavProp = {
    open: boolean;
    onOpen: () => void;
};

export const TopNav = ({ open, onOpen }: TopNavProp) => {
    const { logout } = useAuth();

    const theme = useTheme()
    const colorMode = React.useContext(ColorModeContext);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // const handleManageAccount = async () => {
    //     setAnchorEl(null);
    //     await accountManagement();
    // }

    const handleSignOut = async () => {
        setAnchorEl(null);
        await logout();
    }

    return (
        <AppBar position='fixed' elevation={0} sx={(theme) => ({
            // Fixed height (border-box, so it includes the dark-mode border);
            // the dense Toolbar stretches to fill it.
            height: APP_HEADER_HEIGHT,
            bgcolor: 'banner.main',
            ...(theme.palette.mode === 'dark' && {
                borderBottom: '1px solid',
                borderColor: 'divider',
            }),
        })}>
            <Toolbar variant="dense" sx={{ flex: 1 }}>
                <IconButton
                    aria-label="open drawer"
                    onClick={onOpen}
                    edge="start"
                    sx={[
                        { 
                            mr: 2, 
                            color: 'banner.contrastText'
                        },
                        open && { display: 'none' },
                    ]}
                >
                    <MenuIcon />
                </IconButton>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Typography
                        variant="h3"
                        noWrap component="div"
                        sx={{
                            fontWeight: 700,
                            color: 'banner.contrastText'
                        }}
                    >
                        CliZod
                    </Typography>
                </Link>
                <Box sx={{ flexGrow: 1 }} />


                <IconButton onClick={colorMode.toggleColorMode} sx={{ color: 'banner.contrastText' }}>
                    {
                        theme.palette.mode === "dark" ? (
                            <DarkModeOutlinedIcon />
                        ) : (
                            <LightModeOutlinedIcon />
                        )
                    }
                </IconButton>
                <IconButton onClick={handleMenu} sx={{ color: 'banner.contrastText' }}>
                    <PersonOutlinedIcon />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    sx={{ mt: '24px' }}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {/* <MenuItem onClick={handleManageAccount}>Profile</MenuItem> */}
                    <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}